import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button, Stack, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { createStyles, withStyles } from '@mui/styles';
import { DateConverter } from '../../utils/DateConverter';
import ApproveModal from '../../reusable-component/ApproveModal';
import RejectModal from '../../reusable-component/RejectModal';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'none !important',
    color: '#8798AD',
    padding: '10px',
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '15px',
  },
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid red',
      background: '#FFFFFF',
      boxShadow: '0px 2px 6px #0000000A',
      borderRadius: '5px !important',
    },
  })
)(TableRow);

export default function EngagementTable({ tableData, pagination, onPageChange }) {
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openRejectModal, setOpenRejectModal] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [engagementId, setEngagementId] = React.useState('');

  const totalPages = Math.ceil(pagination.total / pagination.size);

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage - 1);
  };

  const handleApproveModal = (row) => {
    setOpenApproveModal(!openApproveModal);
    if (!openApproveModal) {
      setMessage(`Approve engagement "${row.engagement_name}"?`);
      setEngagementId(row.engagement_id);
    }
  };

  const handleRejectModal = (row) => {
    setOpenRejectModal(!openRejectModal);
    if (!openRejectModal) {
      setMessage(`Reject engagement "${row.engagement_name}"?`);
      setEngagementId(row.engagement_id);
    }
  };

  return (
    <Box>
      <TableContainer>
        <Table style={{ minWidth: 650, borderSpacing: '0px 4px', borderCollapse: 'separate' }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Engagement Name</StyledTableCell>
              <StyledTableCell>Client</StyledTableCell>
              <StyledTableCell>Domain</StyledTableCell>
              <StyledTableCell>Created By</StyledTableCell>
              <StyledTableCell>Created On</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tableData.map((row) => (
              <StyledTableRow key={row.engagement_id}>
                <StyledTableCell>{row.engagement_name}</StyledTableCell>
                <StyledTableCell>{row.client_name}</StyledTableCell>
                <StyledTableCell>{row.domain_name}</StyledTableCell>
                <StyledTableCell>{row.created_by}</StyledTableCell>
                <StyledTableCell>{DateConverter(row.created_at)}</StyledTableCell>

                <StyledTableCell>
                  <Stack direction="row" spacing={2}>
                    <Button size="small" variant="contained" sx={{ background: '#27CC00' }}
                      onClick={() => handleApproveModal(row)}>Approve</Button>

                    <Button size="small" variant="contained" color="error"
                      onClick={() => handleRejectModal(row)}>Reject</Button>
                  </Stack>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ApproveModal
        openApproveModal={openApproveModal}
        handleApproveModal={handleApproveModal}
        fetchData={() => onPageChange(0)}
        type="engagement"
        id={engagementId}
        message={message}
      />

      <RejectModal
        openRejectModal={openRejectModal}
        handleRejectModal={handleRejectModal}
        fetchData={() => onPageChange(0)}
        type="engagement"
        id={engagementId}
        message={message}
      />

      <Pagination
        count={totalPages}
        page={pagination.page + 1}
        onChange={handleChangePage}
        variant="outlined"
        shape="rounded"
        size="small"
        sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}
      />
    </Box>
  );
}
